import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Card, CardActionArea, CardContent, CardMedia, Container, Stack, Typography } from '@mui/material';

const toPlain = (value = '') =>
  String(value)
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const truncate = (value = '', size = 220) => (value.length > size ? `${value.slice(0, size - 1)}...` : value);

const AllNewsMobile = ({ news }) => {
  return (
    <Box sx={{ minHeight: '100%', bgcolor: 'background.default', py: 2 }}>
      <Container maxWidth="sm" sx={{ px: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 800, mb: 2 }}>
          Noticias
        </Typography>

        <Stack spacing={2}>
          {(news || []).map((item) => {
            const subtitle = truncate(toPlain(item.subtitle || ''), 180);
            return (
              <Card key={item.id} variant="outlined" sx={{ borderRadius: 2 }}>
                <CardActionArea component={RouterLink} to={`/news/${item.id}`}>
                  <CardMedia
                    component="img"
                    src={item.image || '/images/hero.png'}
                    alt={item.title || 'Noticia'}
                    sx={{ height: 190, objectFit: 'cover' }}
                  />
                  <CardContent sx={{ p: 2 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                      ID {String(item.id).padStart(4, '0')}
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.25, mb: 1 }}>
                      {item.title}
                    </Typography>
                    {!!subtitle && (
                      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
                        {subtitle}
                      </Typography>
                    )}
                  </CardContent>
                </CardActionArea>
              </Card>
            );
          })}
        </Stack>
      </Container>
    </Box>
  );
};

export default AllNewsMobile;
